<h3 mat-dialog-title>{{data.title}}</h3>
<mat-dialog-content>
    <p [innerHTML]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class = "mr-3" mat-flat-button mat-dialog-close>Cancel</button>
  <button class="btn-positive" 
    [style.backgroundColor]="positiveColor"
    mat-flat-button [mat-dialog-close]="true">{{$confirmTitle}}</button>
</mat-dialog-actions>
